<ncp-table #pregnancies [(options)]="options"></ncp-table>
